import React from 'react';
import { ExtendedFlex } from '../coreui';

const TimelineFiller = ({ dividerProps, ...props }) => {
  return (
    <ExtendedFlex
      {...props}
    >
      <ExtendedFlex
        borderLeft="1px dashed"
        borderColor="blue.0"
        height="100%"
        pt={30}
        pb={50}
        {...dividerProps}
      />
    </ExtendedFlex>
  );
};

export default TimelineFiller;
